module.exports = __webpack_public_path__ + "img/SL.780f1ed6.svg";